






































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { QuestionnaireType } from "../../../../../../../documaker/domain/format/objects";
import { DomainRegistry } from "../../../../../../domain";
import { QuestionnaireGlossaryItem } from "../../../../../../domain/questionnaire";
import { QuestionnaireGlossaryItemSelector } from "../selectors";

@Component({
  components: {
    OptionDropDownSelector,
    QuestionnaireGlossaryItemSelector,
  }
})
export default class QuestionnaireGlossaryItemSelectDialog extends Mixins(DialogMixin) {
  confirmed = false;
  selectableTypes: QuestionnaireType[] = [];
  selectedType: QuestionnaireType = "display";
  items: QuestionnaireGlossaryItem[] = null;
  selectedItem: QuestionnaireGlossaryItem | null = null;
  nameFilterText = "";
  linkIdFilterText = "";

  get selectableTypeOptions(): StandardOption<QuestionnaireType | undefined>[] {
    return this.selectableTypes
      ? this.selectableTypes.map(t => new StandardOption<QuestionnaireType | undefined>(t ? t : "", t))
      : [];
  }

  get selectableItems(): QuestionnaireGlossaryItem[] {
    return (this.isVisible && this.items)
      ? this.items.filter(i => this.selectableFilterTypes.some(v => v === i.type) && this.includesFilter(this.nameFilterText, i.name) && this.includesFilter(this.linkIdFilterText, i.linkId))
      : [];
  }

  private get selectableFilterTypes(): QuestionnaireType[] {
    return !!this.selectedType
      ? this.selectableTypes.filter(v => v === this.selectedType)
      : this.selectableTypes;
  }

  private includesFilter(filter: string, property: string): boolean {
    return filter.toLowerCase().split(/\s/).filter(v => v!!).every(v => property.toLowerCase().includes(v));
  }

  get isItemsLoading(): boolean {
    return !this.items;
  }

  async show(selected: QuestionnaireGlossaryItem | null, selectableTypes: QuestionnaireType[], type: QuestionnaireType): Promise<QuestionnaireGlossaryItem | null> {
    return this.showModal(async () => {
      this.selectedItem = selected;
      this.selectableTypes = selectableTypes;
      this.selectedType = type;
      this.nameFilterText = "";
      this.linkIdFilterText = "";
      if (!this.items) {
        this.items = await DomainRegistry.instance.questionnaire.getGlossaryRepository().getGlossary();
      }
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed
        ? this.selectedItem
        : null;
    });
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
